<div [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">
  <ng-container *ngIf="placeSelector === true">
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>Business name</mat-label>
      <input matInput class="place-name-selector" formControlName="name" />
      <mat-hint>Search for a place by business name</mat-hint>
    </mat-form-field>
  </ng-container>

  <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px">
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>{{
        'patient-intake.patient-information.field-address' | translate
      }}</mat-label>
      <input
        matInput
        type="text"
        name="address1"
        formControlName="address1"
        [placeholder]="placeholder"
        [autocomplete]="autocomplete === 'off' ? 'off' : 'address-line1'"
        [required]="required"
      />
      <mat-hint>{{
        'patient-intake.patient-information.field-address-hint' | translate
      }}</mat-hint>
      <mat-error [translate]="getErrorMessage('address1')"></mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>{{ 'patient-intake.patient-information.field-address' | translate}} (optional)</mat-label>
      <input
        matInput
        type="text"
        placeholder="Suite 3000"
        formControlName="address2"
        [autocomplete]="autocomplete === 'off' ? 'off' : 'address-line2'"
      />
      <mat-hint>{{
        'patient-intake.patient-information.field-address-hint-optional'
          | translate
      }}</mat-hint>
    </mat-form-field>
  </div>

  <!-- <mat-form-field appearance="fill" fxFlex>
    <mat-label>Address Line 3</mat-label>
    <input matInput type="text" formControlName="address3" [autocomplete]="autocomplete === 'off' ? 'off' : 'address-line3'">
  </mat-form-field> -->

  <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px">
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>{{
        'patient-intake.address.field-country' | translate
      }}</mat-label>
      <mat-select formControlName="country" [required]="required">
        <mat-option>
          <ngx-mat-select-search
            *ngIf="countries.length > 1"
            [formControl]="countryFilterCtrl"
            placeholderLabel="Search Country"
            [noEntriesFoundLabel]="'No matching country found'"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let option of filteredCountries | async"
          [value]="option.value"
        >
          {{ option.viewValue }}
        </mat-option>
      </mat-select>
      <mat-error>{{ getErrorMessage('country') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field
      appearance="fill"
      fxFlex
      *ngIf="states && states.length > 0"
    >
      <mat-label>{{
        'patient-intake.address.field-state' | translate
      }}</mat-label>
      <mat-select formControlName="state" [required]="required" (selectionChange)="onStateChange()">
        <mat-option>
          <ngx-mat-select-search
            *ngIf="states.length > 1"
            [formControl]="stateFilterCtrl"
            placeholderLabel="Search State"
            [noEntriesFoundLabel]="'No matching state found'"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let option of filteredStates | async"
          [value]="option.value"
        >
          {{ option.viewValue }}
        </mat-option>
      </mat-select>
      <mat-hint>{{
        'patient-intake.address.field-state-hint' | translate
      }}</mat-hint>
      <mat-error [translate]="getErrorMessage('state')"></mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" fxFlex *ngIf="states == null">
      <input
        matInput
        type="text"
        [placeholder]="'patient-intake.address.field-state' | translate"
        formControlName="state"
        [required]="required"
      />
      <mat-error [translate]="getErrorMessage('state')"></mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="countyFieldVisible$ | async" appearance="fill" fxFlex>
      <mat-label>
        {{'patient-intake.address.field-county' | translate }}
      </mat-label>
      <input
        matInput
        type="text"
        formControlName="county"
      />
    </mat-form-field>
  </div>

  <div fxLayout="row wrap" fxLayout.lt-sm="column" fxLayoutGap="10px">
    <mat-form-field
      *ngIf="
        (form.value.sublocality != null && form.value.sublocality.length > 0) ||
        form.value.country === 'MX'
      "
      appearance="fill"
      fxFlex
    >
      <mat-label>{{
        'patient-intake.address.field-neighborhood' | translate
      }}</mat-label>
      <input
        matInput
        type="text"
        formControlName="sublocality"
        [autocomplete]="autocomplete === 'off' ? 'off' : 'address-level3'"
      />
      <mat-hint>{{
        'patient-intake.address.field-neighborhood-hint' | translate
      }}</mat-hint>
    </mat-form-field>
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>{{
        'patient-intake.address.field-city' | translate
      }}</mat-label>
      <input
        matInput
        type="text"
        placeholder="Boston"
        formControlName="city"
        [autocomplete]="autocomplete === 'off' ? 'off' : 'address-level2'"
        [required]="required"
      />
      <mat-error>{{ getErrorMessage('city') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" fxFlex>
      <mat-label>{{
        'patient-intake.address.field-zip' | translate
      }}</mat-label>
      <input
        matInput
        type="text"
        placeholder="01001"
        formControlName="zip"
        [required]="required"
      />
      <mat-hint>{{
        'patient-intake.address.field-zip-hint' | translate
      }}</mat-hint>
      <mat-error>{{ getErrorMessage('zip') | translate }}</mat-error>
    </mat-form-field>
  </div>
</div>
